import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { shareReplay } from 'rxjs/operators';

import { CheckoutSummaryComponent } from '../shared/checkout/summary.component';
import { LoaderComponent } from '../shared/loader/loader.component';
import { selectCheckoutSummaryVM } from '../../state/donation-flow';

/**
 * Step 3 of the Recurring flow: shown while effects confirm the first
 * invoice's PaymentIntent (SCA) and finalize the subscription. Purely
 * presentational — no Stripe Elements are mounted here.
 */
@Component({
  selector: 'don-recurring-donation-confirmation',
  imports: [CommonModule, TranslateModule, CheckoutSummaryComponent, LoaderComponent],
  templateUrl: './recurring-donation-confirmation.component.html',
  styleUrls: ['./recurring-donation-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringDonationConfirmationComponent {
  private readonly store = inject(Store);

  readonly summaryVm$ = this.store
    .select(selectCheckoutSummaryVM)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));
}
